<template>
  <div class="invoice-pop" v-show="invoiceActive">
    <div class="pop-fp">
      <a class="close-btn" @click="invoiceActive = false">x</a>
      <div class="pop-fp-item">
        <h5>
          收货地址
        </h5>
        <textarea name="" id="" placeholder="请输入收获地址" class="textarea-adress" v-model="addressText"></textarea>
      </div>
      <span class="pop-fp-btn" @click="saveUserInfo">确认</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invoiceActive: false,
      addressText: ''
    };
  },
  methods: {
    openInvoice() {
      this.invoiceActive = true;
      this.getUserInfo(this.invoiceTitleType);
    },
    saveUserInfo() {
      this.invoiceActive = false;
      if(this.addressText.trim()){
        this.$emit("getAddress", this.addressText)
      }
    },
    getUserInfo(invoiceTitleType) {
      
    }
  }
};
</script>

<style scope>
.invoice-pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 5;
}
.invoice-pop .pop-fp {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 556px;
  background: #fff;
  border: 1px solid #9eaacb;
  box-shadow: 0 3px 4px #909090;
  margin: -278px 0 0 -299px;
  padding: 17px 20px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  border-radius: 5px;
}
.fl {
  float: left;
}
.invoice-pop .close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 24px;
  height: 24px;
  background: #ecf3ff;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  color: #166fff;
  text-align: center;
  /* line-height: 22px; */
  font-size: 20px;
  text-decoration: none;
}
.invoice-pop .pop-fp-item h5 {
  font-size: 18px;
  /* line-height: 26px; */
  height: 26px;
  margin-bottom: 15px;
}
.invoice-pop .pop-fp-item h5 span {
  font-size: 16px;
  color: #818181;
  margin-left: 20px;
}
.invoice-pop .pop-fp-item h5 a {
  display: inline-block;
  margin-left: 20px;
  padding: 0 18px;
  background: #fff;
  font-size: 16px;
  /* line-height: 22px; */
  color: #323232;
  height: 24px;
  border: 1px solid #efefef;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  font-weight: normal;
  vertical-align: top;
}
.invoice-pop .pop-fp-item h5 a.cur {
  background: #ecf3ff;
  border-color: #166fff;
  color: #166fff;
}
.invoice-pop .pop-fp-item {
  margin-bottom: 22px;
}
.invoice-pop .pop-fp-item div {
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  margin-bottom: 15px;
}
.invoice-pop .pop-fp-item div.ipt-w input {
  width: 255px;
}
.invoice-pop .pop-fp-item div input {
  padding: 0 10px;
  height: 18px;
  border: 0;
  border-left: 1px solid #3179ff;
  width: 400px;
}
.invoice-pop .ipt-tit {
  width: 92px;
  text-align: right;
  margin-right: 15px;
}
.invoice-pop .pop-fp-btn {
  display: block;
  width: 100%;
  font-size: 18px;
  color: #fff;
  text-align: center;
  background: #166fff;
  line-height: 40px;
  height: 40px;
  text-decoration: none;
  cursor: pointer;
}
.invoice-pop .pop-fp-rules {
  font-size: 16px;
  margin-top: 10px;
}
.invoice-pop .pop-fp-rules dt {
  line-height: 30px;
}
.invoice-pop .pop-fp-rules dd {
  background: #f2f2f2;
  overflow: hidden;
  overflow-y: auto;
  height: 94px;
  padding: 10px;
}
.invoice-pop .pop-fp-rules dd p {
  line-height: 1.5;
}
.textarea-adress{
  border: 1px solid #ccc;
  padding: 10px;
  width: 530px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/Invoice.vue